<div *ngIf="dprApprover" class="d-flex justify-content-between align-items-center approverInput">
  <span
    *ngIf="!isEditModeOn || !canEdit; else editTemplate"
    (click)="enterEditMode()"
    [ngClass]="{ 'cursor-pointer' : canEdit }"
  >
    {{dprApprover.name}}
  </span>
  <ng-template #editTemplate>
    <!-- <div class="d-flex justify-content-between"> -->
    <mat-form-field class="d-flex flex-1 pr-2">
      <input
        data-testId="edit-approver"
        matInput
        #nameInput
        [(ngModel)]="editedName"
        autocomplete="off"
        maxlength="200"
      />
      <button
        mat-flat-button
        data-testId="save"
        matSuffix
        class="mat-secondary button--square button--xsmall mb-1"
        [disabled]="editedName | isNullOrWhitespace"
        [matTooltip]="StaticMessage.SaveButton | staticMessage"
        (click)="onSave()"
      >
        <mat-icon svgIcon="check"></mat-icon>
      </button>
    </mat-form-field>
    <!-- </div> -->
  </ng-template>
  <button
    *ngIf="canEdit"
    data-testId="delete"
    mat-flat-button
    color="warn"
    class="button--square button--xsmall align-self-start mat-secondary-danger"
    [matTooltip]="StaticMessage.DeleteButton | staticMessage"
    (click)="onDelete()"
  >
    <mat-icon svgIcon="delete-forever"></mat-icon>
  </button>
</div>
